import { U21ChipColor } from 'app/shared/u21-ui/components';
import { InvestigationStatus } from 'app/modules/investigations/models';

export const STATUS_TO_COLOR: Record<InvestigationStatus, U21ChipColor> = {
  OPEN: 'success',
  CLOSED: 'error',
  IN_REVIEW: 'warning',
};

// Hard ceiling on the number of investigation IDs a single select-all bulk
// action will gather and process
export const MAX_BULK_ACTION_IDS = 10000;
